"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="calltoaction" ref={ref} className="![padding:125px_32px_128px_32px]" style={{
    backgroundColor: "#8b6e4c"
  }}>
      <div className="mx-auto max-w-3xl text-center">
        <div className={`space-y-6 transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="text-[45px] font-bold tracking-tight !text-white">
  Let’s Build Something Exceptional <br />
  Together
</h2>
          
<p className="mx-auto max-w-2xl text-lg !text-white sm:text-xl">
  Whether you are planning a private residence or a commercial space,
  <br />
  <span className="font-semibold">KS LUXURY RENOVATIONS</span> offers the experience and structure needed to deliver with confidence.
</p>
          
          <div className="pt-4">
            <Link to="/Contact">
            <Button size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive bg-primary shadow-xs h-10 rounded-md has-[>svg]:px-4 btn-primary text-base px-8 py-6 ![margin:0px_0px_50px_0px] !text-[hsl(0,0%,100%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 sm:text-lg">Contact Us</Button>
          </Link>
             </div>
        </div>
      </div>
    </section>;
}